import { render, staticRenderFns } from "./CandidateAdd.vue?vue&type=template&id=4290712e&"
import script from "./CandidateAdd.vue?vue&type=script&lang=js&"
export * from "./CandidateAdd.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports